import React from "react"
import { CSVLink } from "react-csv"
import { FaDownload } from "react-icons/fa"
import { useNavigate } from "react-router-dom"

import commonJson from "./../json/common.json"
import displayJson from "./../json/display.json"
import eventJson from "./../json/event.json"
import goodsJson from "./../json/goods.json"
import memberJson from "./../json/member.json"
import orderJson from "./../json/order.json"

export const CommomnData = () => {
	return commonJson
}
export const DisplayData = () => {
	return displayJson
}
export const EventData = () => {
	return eventJson
}
export const GoodsData = () => {
	return goodsJson
}
export const MemberData = () => {
	return memberJson
}
export const OrderData = () => {
	return orderJson
}

const commonjs = require("./../js/common.js")
const jp = require("jsonpath")

const getCsvData = (modulsName) => {
	let jsonData
	switch (modulsName) {
		case "common":
			jsonData = CommomnData()
			break
		case "display":
			jsonData = DisplayData()
			break
		case "event":
			jsonData = EventData()
			break
		case "goods":
			jsonData = GoodsData()
			break
		case "member":
			jsonData = MemberData()
			break
		case "order":
			jsonData = OrderData()
			break
		default:
			jsonData = ""
			break
	}

	const names = jp.query(jsonData, "$..paths")[0]

	let csvData = []

	for (const [path, value] of Object.entries(names)) {
		let objectArr = Object.keys(value)

		for (let i = 0; i < objectArr.length; i++) {
			let rowdata = { path: path }
			let row = value[objectArr[i]]

			rowdata.method = objectArr[i]
			rowdata.tag = row.tags[0]
			rowdata.operationId = row.operationId
			rowdata.summary = row.summary
			rowdata.api = commonjs.CsvUrl(modulsName, row.tags[0], row.operationId)
			csvData.push(rowdata)
		}
	}
	return csvData
}

const Content = () => {
	const navigate = useNavigate()
	const moduleNames = ["common", "display", "event", "goods", "member", "order"]
	return (
		<>
			<div className="p-4 mt-4">
				<div className="grid grid-cols-3 grid-rows-2 gap-4">
					<div className="row-span-1 text-center p-3 col-span-3">
						<h2>Csv File Down</h2>
					</div>
					{moduleNames.map((item, index) => (
						<div className="col-span-1 row-span-1 text-center p-3" key={"csv-" + item}>
							<CSVLink filename={item + "-file.csv"} data={getCsvData(item)} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center justify-center">
								<FaDownload className="mr-2" /> {item} Download
							</CSVLink>
						</div>
					))}
				</div>
			</div>
		</>
	)
}

export default Content
